module.exports = __webpack_public_path__ + "img/labs-yankee-scamming.5a3f071c.png";